export enum StickyCardShapes {
  HOUSE = 'house',
  OVERFLOWING = 'overflowing'
}

export enum StickyCardColors {
  DARK = 'dark',
  WARM = 'warm',
  SOFT = 'soft',
  VIBRANT = 'vibrant'
}

export type StickyCardProps = {
  _childIndex?: number
  title: string
  description: string
  image?: {
    alt: string
    publicId: string // cloudinary public ID
    shape?: StickyCardShapes
  }
  color: StickyCardColors
}
